export default __webpack_public_path__ + "static/michael-612c1582660b5308f857a0df992c422c.jpg";